import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import type { LiteraryDesignUnitVisualData, SlideState } from "../../types.d";
import type { SlideViewMode } from "../slide/slide";

const LITERARY_DESIGN_DEFAULT_WIDTH = 680;

@customElement("bp-ephesians-literary-design-slide")
export class EphesiansLiteraryDesignSlide extends LitElement {
  @property()
  data?: LiteraryDesignUnitVisualData;

  @property({ attribute: "hide-title" })
  hideTitle?: boolean;

  @property()
  slideState?: SlideState;

  @property({ attribute: "title-wraps-2-lines" })
  titleWraps2Lines?: boolean;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  render() {
    if (!this.data) return;

    const { usx, html: designHTML } = this.data;
    const useFallback = usx && usx.length > 0;
    const style = useFallback
      ? `width: ${LITERARY_DESIGN_DEFAULT_WIDTH}px`
      : "";
    const content = useFallback
      ? html`<bp-literary-design usx="${usx}" />`
      : html`<bp-ephesians-literary-design .data="${designHTML}" />`;

    return html`
      <bp-zoomable-slide
        ?hide-title=${this.hideTitle}
        ?title-wraps-2-lines=${this.titleWraps2Lines}
        ?large-content-mode=${!useFallback}
        view-mode="${this.viewMode}"
        .slideState=${this.slideState}
      >
        <div slot="title">
          <slot name="title"></slot>
        </div>
        <div slot="content" style="${style}">${content}</div>
      </bp-zoomable-slide>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-ephesians-literary-design-slide": EphesiansLiteraryDesignSlide;
  }
}
